import { render } from "./SupportPage.vue?vue&type=template&id=ac203cbc&scoped=true"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"

import "./SupportPage.vue?vue&type=style&index=0&id=ac203cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac203cbc"]])

export default __exports__